// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorModal_root__2F7Rl","icon":"ErrorModal_icon__3Lrkr","text":"ErrorModal_text__E8Zhv"};